/**
 * A barra de endereços como estado reativo: o caminho diz QUAL tela, a query diz
 * COMO ela está olhando os dados.
 *
 * A separação é de propósito. Tela é recurso e vira caminho (`/costs`), então o
 * link é legível e o histórico do navegador tem uma entrada por tela. Filtro e
 * recorte são estado da mesma tela e ficam na query (`?aba=&de=&ate=`), porque
 * mudar de aba não muda o que se está olhando, só como.
 */
class Navigation {
  private current = $state({
    path: window.location.pathname,
    search: window.location.search,
  });

  constructor() {
    window.addEventListener('popstate', () => {
      this.current = {
        path: window.location.pathname,
        search: window.location.search,
      };
    });
  }

  get path(): string {
    return this.current.path;
  }

  valueOf(key: string): string | null {
    return new URLSearchParams(this.current.search).get(key);
  }

  /**
   * Troca de tela preservando a query — voltar para Custos devolve o mesmo período.
   * O patch, quando vem, muda a query na mesma entrada do histórico.
   */
  goTo(path: string, patch: Record<string, string | null> = {}): void {
    const search = this.searchWith(patch);
    if (path === this.current.path && search === this.current.search) return;
    this.push(path, search);
  }

  /** Grava o patch na query. Chave com valor vazio sai da URL — ausência é o padrão. */
  merge(patch: Record<string, string | null>): void {
    this.goTo(this.current.path, patch);
  }

  private searchWith(patch: Record<string, string | null>): string {
    const next = new URLSearchParams(this.current.search);
    for (const [key, value] of Object.entries(patch)) {
      if (!value) {
        next.delete(key);
        continue;
      }
      next.set(key, value);
    }
    const search = next.toString();
    return search ? `?${search}` : '';
  }

  private push(path: string, search: string): void {
    this.current = { path, search };
    window.history.pushState({}, '', `${path}${search}`);
  }
}

export const navigation = new Navigation();
